import { z } from 'zod';

export const PaySlipSearchSchema = z.object({
  year: z.number().default(2026),
  month: z.number().min(1).max(12).default(1),
  freeText: z.string().default(''),
  pageSize: z.number().default(100),
  pageIndex: z.number().default(0),
});

export type PaySlipSearchParams = z.infer<typeof PaySlipSearchSchema>;

/** 従業員別明細タブ: 年月（未指定時は beforeLoad で最新月へリダイレクト） */
export const EmployeePaySlipDetailSearchSchema = z.object({
  year: z.coerce.number().int().min(2000).max(2100).optional(),
  month: z.coerce.number().int().min(1).max(12).optional(),
});
